import React, { useState } from "react";
import PhoneInput from "react-phone-number-input";
import { Field } from "formik";
import { useTranslation } from "react-i18next";
import "react-phone-number-input/style.css";

const PhoneField = (props) => {
  const {
    field,
    errors = {},
    name,
    touched = {},
    label,
    onChange,
    form: { handleBlur, setFieldValue },
  } = props;
  let validatyClass = "";
  if (!!errors[field.name] && !!touched[field.name]) {
    validatyClass = "is-invalid";
  }
  if (!errors[field.name] && !!touched[field.name]) {
    validatyClass = "is-valid";
  }

  const onValueChange = (phoneNumber) => {
    setFieldValue(name, phoneNumber);

    if (onChange !== null) {
      onChange(phoneNumber);
    }
  };

  const { t } = useTranslation();
  const [country, setCountry] = useState("US");

  return (
    <div>
      <PhoneInput
        country={country}
        placeHolder={field.placeHolder}
        name={field.name}
        value={field.value}
        international={true}
        onChange={onValueChange}
        countryCallingCodeEditable={false}
        defaultCountry="US"
      />
      <div className="invalid-feedback">Error</div>
    </div>
  );
};

function FormInput(props) {
  const { name } = props;
  return (
    <>
      <div className="field-group">
        <Field name={name} component={PhoneField} {...props} />
      </div>
    </>
  );
}
export default FormInput;
